jQuery(document).ready(function () {
    'use strict';

    var configuration = {},
        body = jQuery('body');

    if (typeof body.data('sentry-release') !== 'undefined') {
        configuration.release = body.data('sentry-release');
    }

    Raven.config(body.data('sentry-dsn'), configuration).install();
});
